import type { ReploShopifyProduct } from "schemas/runtimeProduct";

export default function isLoadingProduct(product: ReploShopifyProduct) {
  return product?.handle === "loading-product";
}
